export const resolveDate = (date) => {
	let d = null
	if (date === null) {
		return null
	}

	if (date.indexOf('-') !== -1) {
		// Score date
		d = date.split('-')
	} else {
		// Slash date
		d = date.split('/')
	}
	if (d.length === 3) {
		if (d[2].toString().length === 4) {
			return d.join('-')
		} else {
			return d.reverse().join('-')
		}
	} else {
		return null
	}
}



// WEBPACK FOOTER //
// ./src/common/services/ResolveDate.js